const INVITATION_PAGE_PATH = '/group-member-invitations';

const storageKey = (invitationId: string): string => `balus:invitation-token:${invitationId}`;

/**
 * 招待メールのリンクの確認トークンを sessionStorage に退避し、URL から取り除く。
 * Firebase Analytics・Sentry・各種ログがURLを収集する前に呼ぶことで、生トークンの流出経路を断つ。
 * 退避できなかった場合は、登録できなくなるのを避けるため URL をそのまま残す。
 */
export const stashInvitationTokenFromUrl = (): void => {
  try {
    if (window.location.pathname !== INVITATION_PAGE_PATH) return;

    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    const invitationId = url.searchParams.get('invitationId');
    if (!token || !invitationId) return;

    window.sessionStorage.setItem(storageKey(invitationId), token);
    url.searchParams.delete('token');
    window.history.replaceState(window.history.state, '', url.toString());
  } catch {
    // sessionStorage が使えない環境では URL にトークンを残す
  }
};

export const readStashedInvitationToken = (invitationId: string): string | null => {
  try {
    return window.sessionStorage.getItem(storageKey(invitationId));
  } catch {
    return null;
  }
};
